import { Shield } from 'lucide-react'

interface CertBadgeProps {
  name: string
  /** Extra text shown after the name (e.g. Gas Safe number). */
  suffix?: string
  size?: 'sm' | 'md'
}

export function CertBadge({ name, suffix, size = 'md' }: CertBadgeProps) {
  if (size === 'sm') {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-medium text-trust-600 bg-trust-50 border border-trust-100 px-1.5 py-0.5 rounded-full">
        <Shield className="h-2.5 w-2.5" />
        {name}
        {suffix && <span className="text-trust-400 font-normal">{suffix}</span>}
      </span>
    )
  }

  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium bg-trust-50 text-trust-700 border border-trust-100 px-2.5 py-1.5 rounded-full">
      <Shield className="h-3 w-3" />
      {name}
      {suffix && <span className="text-trust-400 font-normal ml-0.5">{suffix}</span>}
    </span>
  )
}
